import React, {useEffect, useRef, useState} from "react";
import { BsSend } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";
import {FaUser} from "react-icons/fa";

const TicketPage = () => {
  const { id } = useParams();
  console.log(id);

  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [ticketData, setTicketData] = useState({ subject: "", seller: "" });
  const [inputData, setInputData] = useState("");

    const messagesContainerRef = useRef(null);

  const fetchMessages = () => {
    apiRequests
      .get(`/api/tickets/v1/get-ticket-messages-admin/${id}`)
      .then((response) => {
        const data = response?.data?.data;
        setMessages(data?.findMessages || []);
        setTicketData({
          subject: data?.subject,
          seller:
            data?.findMessages?.[0]?.ticket_id?.creator?.seller_id?.userName || "Unknown",
        });
      })
      .catch((err) => console.error("Error:", err));
  };

  const sendMessage = () => {
    apiRequests
      .put(`/api/tickets/v1/admin-answer-ticket`, {
        ticket_id: id,
        description: inputData,
      })
      .then((res) => {
        if (res.status === 200) {
          toast.success("message sent successfully");
          fetchMessages();
          setInputData("");
        }
      })
      .catch((err) => console.error("Error:", err));
  };

  useEffect(() => {
    fetchMessages();
  }, [id]);

    useEffect(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTo({
                top: messagesContainerRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [messages]);

  return (
    <div className="p-6 w-full flex flex-col h-screen relative">
      <header className="flex justify-between items-center sm:text-sm">
        <button
          onClick={() => navigate(-1)}
          className="bg-baseColor-second/70 text-white py-2 px-3 rounded-xl"
        >
          back to chats
        </button>
        <p>
          subject :{" "}
          <span className="text-xl font-semibold sm:text-sm">
            {ticketData.subject}
          </span>
        </p>
        <p>
          sender :{" "}
          <span className="text-xl font-semibold sm:text-sm">
            {ticketData.seller}
          </span>
        </p>
      </header>

      <div ref={messagesContainerRef} className="flex-1 h-52 overflow-y-auto border border-gray-300 rounded-xl p-3 mt-3 space-y-4 pb-12">
        {messages.map((msg) => {
          const isAdmin = !!msg.sender.admin_id;
          return (
            <div
              key={msg._id}
              className={`flex gap-1 ${isAdmin ? "justify-end" : "justify-start"}`}
            >
                {!isAdmin && (
                    <div className="flex items-end">
                        <div className="w-7 h-7 rounded-full bg-baseColor-second flex items-center justify-center">
                            <FaUser className="text-gray-100"/>
                        </div>
                    </div>
                )}
              <div
                className={`p-3 rounded-xl max-w-[60%] ${isAdmin ? "bg-baseColor-second text-white" : "bg-gray-100"}`}
              >
                <p>{msg.description}</p>
                <span className="text-[10px] opacity-70 block text-right">
                  {new Date(msg.createdAt).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
            </div>
          );
        })}
      </div>
        <div className="w-full">
            <div className="fixed bottom-1 right-[25px] md:left-0 w-[76%] md:w-full flex justify-between items-center px-3 py-1 border border-gray-600 rounded-xl mt-2 bg-slate-200">
                <input
                    type="text"
                    placeholder="send message"
                    className="w-[90%] p-3 outline-none bg-slate-200"
                    value={inputData}
                    onChange={(e) => {
                        setInputData(e.target.value);
                    }}
                />
                <button className="flex justify-center items-center border border-baseColor-second p-2 rounded-full">
                    <BsSend
                        className="w-5 h-5 cursor-pointer hover:text-baseColor-second"
                        onClick={sendMessage}
                    />
                </button>
            </div>
        </div>

    </div>
  );
};

export default TicketPage;
